// extracted by mini-css-extract-plugin
module.exports = {"requirements":"RequestCustomerUploadPopup_requirements__3IbtB","sendEmailButton":"RequestCustomerUploadPopup_sendEmailButton__If9F3"};